import React from 'react';

import './Style.css';

class TabelaAvaliacoes extends React.Component {

    formatDate = (value, period = false) => {
        if (value === null || value === undefined || value === '') {
            return '-';
        }

        const dateObj = new Date(value);

        if(period) {
            return new Intl.DateTimeFormat('pt-BR', {
                month: '2-digit',
                year: 'numeric',
            }).format(dateObj);
        }

        return new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(dateObj);
    }

    render() {
        const {
            user,
            notas,
            demeritos,
            onShowModalAvaliacao,
            onShowModalDemerito,
        } = this.props;

        return (
            <>
                <div
                    className=""
                    style={{
                        overflowY: 'scroll',
                    }}
                >
                    <div>
                        <label>Operador: {user.name}</label>
                    </div>

                    <table className="table table-hover table-condensed table-striped cidades">
                        <thead>
                            <tr>
                                <th>Data da Avaliação</th>
                                <th>Período da Atualização</th>
                                <th>Estado / Cidade</th>
                                <th>Empreendimento</th>
                                <th>Nota</th>
                                <th>Motivo / Critério</th>
                                <th>Tipo de Avaliação</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {notas.map((avaliacao) => (
                                <tr key={avaliacao.id}>
                                    <td className="text-center">
                                        {this.formatDate(avaliacao.created_at)}
                                    </td>
                                    <td className="text-center">
                                        {this.formatDate(avaliacao.period, true)}
                                    </td>
                                    <td className="text-center">
                                        {avaliacao.building?.city?.state} / {avaliacao.building?.city?.city}
                                    </td>
                                    <td className="text-center">
                                        <a
                                            href={`/building/${avaliacao.building_id}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {avaliacao.building?.name}
                                            {' '}
                                            <i className="fa fa-link"></i>
                                        </a>
                                    </td>
                                    <td className="text-center">
                                        {avaliacao.evaluation_weigth?.weigth || 0}
                                    </td>
                                    <td className="text-center">
                                        {avaliacao.criteria && avaliacao.criteria.map((reason) => (
                                            <p>{reason.evaluation_weigth?.reason || ''} / {reason.evaluation_weigth?.criterion || ''}</p>
                                        ))}
                                    </td>
                                    <td className="text-center">
                                        {avaliacao.tipo}
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-editar"
                                            title="Editar"
                                            onClick={() =>
                                                onShowModalAvaliacao(avaliacao.id)
                                            }
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {demeritos.map((demerito) => (
                                <tr key={demerito.id}>
                                    <td className="text-center">
                                        {this.formatDate(demerito.created_at)}
                                    </td>
                                    <td className="text-center">
                                        {this.formatDate(demerito.period, true)}
                                    </td>
                                    <td className="text-center">
                                        {demerito.building?.city?.state} / {demerito.building?.city?.city}
                                    </td>
                                    <td className="text-center">
                                        <a
                                            href={`/building/${demerito.building_id}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {demerito.building?.name}
                                            {' '}
                                            <i className="fa fa-link"></i>
                                        </a>
                                    </td>
                                    <td className="text-center">
                                        {demerito.evaluation_weigth?.weigth || 0}
                                    </td>
                                    <td className="text-center">
                                        {demerito.criteria && demerito.criteria.map((reason) => (
                                            <p>{reason.evaluation_weigth?.reason || ''} / {reason.evaluation_weigth?.criterion || ''}</p>
                                        ))}
                                    </td>
                                    <td className="text-center">
                                        {demerito.tipo}
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-editar"
                                            title="Editar"
                                            onClick={() =>
                                                onShowModalDemerito(demerito.id, demerito.city_period_id)
                                            }
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
}

export default TabelaAvaliacoes;